function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const React = require('react');

function SvgAdvertisingCloudColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fa0f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.839 4.607c-3.6 0-6.536 3.126-6.757 7.151H3.39v.2c0 4.213 3.038 7.641 6.771 7.641 3.6 0 6.538-3.128 6.757-7.153h3.692v-.2c0-4.212-3.038-7.639-6.771-7.639zm-3.678 14.3a5.843 5.843 0 0 1-4.853-2.75A4.627 4.627 0 0 0 8.3 17.19c2.245 0 4.258-1.761 5.417-4.749h2.516c-.215 3.644-2.849 6.47-6.072 6.47zM13.839 5.29a6.127 6.127 0 0 1 5.514 4.01 3.734 3.734 0 0 0-2.787-1.234c-2.416 0-3.458 1.86-4.151 3.7H7.766c.217-3.651 2.85-6.476 6.073-6.476zM8.3 15.728a3.228 3.228 0 0 1-3.279-3.287h7.109c-.53 1.168-1.792 3.287-3.83 3.287zm8.264-6.2a2.409 2.409 0 0 1 2.353 2.234h-4.925c.688-1.606 1.425-2.238 2.574-2.238z",
    fill: "#fff"
  }));
}

module.exports = React.memo(SvgAdvertisingCloudColor);